import { handleBmpProductViewImpression, getProductCardContainers } from '@common/Tracking/BmpProductView/handlers';

export const trackBmpProductView = () => {
    for (const ssrProductCardContainer of getProductCardContainers()) {
        const productCardContainer = ssrProductCardContainer ? document.querySelector(`${ssrProductCardContainer}`) : null;

        if (productCardContainer) {
            const { children } = productCardContainer;

            if (children.length > 0) {
                for (let i = 0; i < children.length; i++) {
                    children[i].addEventListener('click', () => {
                        handleBmpProductViewImpression(children[i]);
                    });
                }
            }
        }
    }
};
